import { mapGetters, mapMutations } from 'vuex';
import { getPlanTypeByCategory } from '@/common/service/parse';
import { pageConfig } from '@/common/service/page-config';
import { filter, get, groupBy, orderBy } from 'lodash';
import { planTypes } from "@/common/constants";
import {
  BILLING_CYCLE as BillingCycle,
  dependMeetingPlanTypeList,
  limitLicenseWithBaseZoneTypes,
} from '@/common/constants';
import { PBX_SUB_TYPES } from '@/common/service/computers/plans/pbx';

export default {
  created() {
    const { amount } = this.lowestPlan;
    this.subtitle = this.$t('billing.common.form_xx_month', [this.$money(amount)]);
    this.productPlans = this.currentProductPlans;
  },
  data() {
    return {
      form: {
        selectedNumber: 1,
        //billingCycle
        //category
      },
    };
  },
  computed: {
    ...mapGetters(['getSelectedPlans', 'planMapFlat', 'pastPlans', 'getSelectedPlans', 'learnMoreConfig']),
    currentProductPlans() {
      return orderBy(
        filter(this.planMapFlat, (p) => p.type === this.planType),
        ['capacity'],
        'asc',
      );
    },
    lowestPlan() {
      return get(this.currentProductPlans, [0], {});
    },
    basePlanBillingCycle() {
      let basePlanType = '';
      if (this.form.billingCycle) {
        return this.form.billingCycle;
      }
      if (limitLicenseWithBaseZoneTypes.includes(this.planType)) {
        basePlanType = [...new Set(this.getSelectedPlans.map((x) => x.type))].find((x) => dependMeetingPlanTypeList.includes(x)) || planTypes.ZOOM_MEETING;
      } else {
        basePlanType = getPlanTypeByCategory(pageConfig.plan || 'pro');
      }
      const targetBillingCycle = this.getSelectedPlans.filter(item=>item.sub_type!==PBX_SUB_TYPES.BASE)?.find((item) => item.type === basePlanType)?.billing_cycle
      if (targetBillingCycle && [BillingCycle.ANNUAL, BillingCycle.MONTHLY].includes(targetBillingCycle)) {
        return targetBillingCycle;
      }
      return BillingCycle.ANNUAL;
    },
    planInfo() {
      return this.planMapFlat.filter((item) => item.type === this.planType);
    },
    planInfoGroupByCategory() {
      return groupBy(this.planInfo, 'category');
    },
    addCategoryCode() {
      const {
        planCode,
      } = this.pastPlans.find((item) => planTypes[item.semanticType] === this.planType) || {};
      // winBack category
      if (planCode) {
        for (const [category, plans] of Object.entries(this.planInfoGroupByCategory)) {
          if (plans.some(plan => plan.plan_code === planCode)) {
            return category;
          }
        }
      }
      const sortedKeys = Object.keys(this.planInfoGroupByCategory).sort((a, b) => {
        const numA = parseInt(a.replace(/\D/g, ''), 10);
        const numB = parseInt(b.replace(/\D/g, ''), 10);
        return numA - numB;
      });
      return this.form.category || sortedKeys[0];
    },
    formPlan() {
      let planInfo;
      if (this.learnMoreConfig?.categoryCode) {
        planInfo = this.planInfoGroupByCategory?.[this.learnMoreConfig.categoryCode];
      }
      if (!planInfo) {
        planInfo = this.planInfoGroupByCategory?.[this.addCategoryCode];
      }
      return planInfo?.find?.(
        (item) => item.billing_cycle === this.basePlanBillingCycle,
      );
    },
  },
  methods: {
    ...mapMutations(['updateSelectPlan','savePersist']),
    addOn(evt) {
      // addPlanFromEnterKey For A11Y requirement
      // target is BUTTON comes from keyboard enter, will auto focaus on the first option in config card
      // target is SPAN comes from click
      const addPlanFromEnterKey = get(evt?.target, 'tagName', '') == 'BUTTON';
      if (addPlanFromEnterKey) {
        document.addPlanFromEnterKey = true;
      }
      this.updateSelectPlan({
        ...this.formPlan,
        cartInfo: {
          selected_number: this.form.selectedNumber || 1,
        },
      });
      this.$emit('add', this.$options?.key);
      this.$tracking.addOnBuyInteraction(`${this.trackingBasePlanName} add-ons`, `add-ons - ${this.title?.toLowerCase()} - ${this.trackingAddAction}`);
      this.$nextTick(this.focusToConfig);
    },
  },
};
